export default "__VITE_ASSET__DIZG00nY__"